import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './../actions';

class GroupSameLineups extends Component {
    onClick(isChecked) {
        this.props.dispatch(Action.do('useGroupingSameLateSwapLineups', isChecked));
    }

    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isModeLateswap();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {groupSameLineups} = this.props;

        const isChecked = groupSameLineups.isUsed();

        return (
            <div className="input-info top-info">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" checked={isChecked} onChange={(e) => ::this.onClick(e.target.checked)} />
                        Group the same lateswap lineups
                    </label>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        lateSwap: {groupSameLineups},
    } = state;

    return {
        sportConfig,
        groupSameLineups,
    };
}

export default connect(mapStatesToProps)(GroupSameLineups);
